export const INVOICE_DOCUMENT_TYPES = [
  {
    value: "invoice",
    label: "Invoice",
    description: "Standard invoice for services or products",
    brandingTitleKey: "invoice_title",
  },
  {
    value: "tax_invoice",
    label: "Tax Invoice",
    description: "Tax invoice with registered tax details",
    brandingTitleKey: "tax_invoice_title",
  },
  {
    value: "quotation",
    label: "Quotation Invoice",
    description: "Quote or proforma before final billing",
    brandingTitleKey: "proforma_invoice_title",
  },
  {
    value: "receipt",
    label: "Receipt",
    description: "Payment receipt for completed transactions",
    brandingTitleKey: "receipt_title",
  },
  {
    value: "credit_note",
    label: "Credit Note",
    description: "Credit issued against a previous invoice",
    brandingTitleKey: "credit_note_title",
  },
  {
    value: "debit_note",
    label: "Debit Note",
    description: "Additional charge against a client account",
    brandingTitleKey: "debit_note_title",
  },
  {
    value: "refund_receipt",
    label: "Refund Receipt",
    description: "Confirmation of refunded payment",
    brandingTitleKey: "refund_receipt_title",
  },
  {
    value: "statement",
    label: "Statement of Account",
    description: "Summary of account activity and balance",
    brandingTitleKey: "statement_title",
  },
];

export const getInvoiceDocumentTypeLabel = (value) =>
  INVOICE_DOCUMENT_TYPES.find((item) => item.value === value)?.label || value || "—";

export function getBrandingTitleForDocumentType(branding, documentType) {
  const typeDef = INVOICE_DOCUMENT_TYPES.find(
    (item) => item.value === documentType,
  );
  if (!typeDef) return "";
  if (!branding) return typeDef.label.toUpperCase();

  const title = String(branding[typeDef.brandingTitleKey] || "").trim();
  return title || typeDef.label.toUpperCase();
}
